<!-- <template>
  <div :class="inlinerows == 'true' ? 'mb-3 row' : 'mb-3'">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? 'col-sm-2 col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? 'col-sm-10' : label ? 'row' : 'col-md-12'">
    -->
      <!-- <b-form-file
        v-model="file1"
        :state="Boolean(file1)"
        :placeholder="placeholder"
        :drop-placeholder="dropplaceholder"
      ></b-form-file> -->
<template>
  <div :class="inlinerows == 'true' ? inlinerowclasses + ' row' : inlinerowclasses">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? inlineLabelClass + ' col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? inlineInputClass : label ? '' : 'col-md-12'">
      

      <div class="custom-file-input-x col-md-12">
        <div class="dropzone-container row" @dragover="dragover" @dragleave="dragleave" @drop="drop">
          <input type="file" :name="'fields[' + id + ']'" :id="id" class="w-px h-px opacity-0 overflow-hidden absolute" @change="onChange" ref="file" accept=".pdf,.jpg,.jpeg,.png" />

          <div class="col-md-6 upload-section">
            <div class="row dotted-border  mr-0">
              <div class="col-6 img-container d-flex justify-content-center align-items-center">
                <i class="fa fa-cloud-upload" aria-hidden="true"></i>
              </div>
              <div class="col-6 text-container">
                <label :for="id" class="">
                  <div>
                    {{ $t(LangConstants.upload_your_picture_input) }} <br />
                    <span class="special">{{ $t(LangConstants.or_click_here_text) }}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div class="col-md-6 display-section" v-if="filelist.length" v-cloak>
            <div class="row" v-for="file in filelist" v-bind:key="file">
              <div class="col-md-6 filenames-holder ">
                <div class="file-temp-element d-flex align-items-center">
                  <div>
                    <i class="fa fa-picture-o" aria-hidden="true"></i>
                    &nbsp;
                    <span class="file-name" :title="file.name">{{ file.name }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6 remove-buttons">
                <button class="btn btn-box-general-grey mb-3 collapsed" type="button" @click="remove(filelist.indexOf(file))" :title="$t(LangConstants.remove_file_title)"><i class="fa fa-trash" aria-hidden="true"></i> &nbsp; {{ $t(LangConstants.delete_file_button_label) }}</button>

                <!-- <my-button
                  @click="remove(filelist.indexOf(file))"
                    fa="trash"
                    label="Delete File"
                    variant="box-general-grey"
                    classes="mb-3"
                    height="47px"
                    :width="btn_width"
                  ></my-button>  -->
              </div>
            </div>
          </div>
        </div>
        <small class="input-error" v-if="error">{{ error }}</small>
      </div>


    </div>
  </div>
</template>

<script>
import "../../assets/scss/form-group.scss";
import "../../assets/scss/file.scss";
import Constants from "../../constants/index";
// import MyButton from "../components/Button.vue";

export default {
  name: "file-input",
  delimiters: ["${", "}"],
  data() {
    return {
      text: "",
      filelist: [],
    };
  },
  props: {


    label: {
      type: String,
      required: true,
    },
    inlinerows: {
      default: false,
    },
    inlinerowclasses: {
      default: "mb-3",
    },
    inlineLabelClass: {
      default: "col-sm-2",
    },
    inlineInputClass: {
      default: "col-sm-10",
    },
    error: {
      type: String,
      default: "",
    },


    // inlinerows: {
    //   // type: Boolean,
    //   default: false,
    // },
    // label: {
    //   type: String,
    //   required: true,
    // },









    id: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      required: false,
    },
    dropplaceholder: {
      type: String,
      required: false,
    },

  },
  methods: {
    onChange() {
      this.filelist = [...this.$refs.file.files];
    },
    remove(i) {
      this.filelist.splice(i, 1);
      this.$refs.file.value = null;
    },
    clearAll() {
      this.filelist = [];
      this.$refs.file.value = null;
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("");
        event.currentTarget.classList.add("");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("");
      event.currentTarget.classList.remove("");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("");
      event.currentTarget.classList.remove("");
    },
  },
  computed: {
    LangConstants() {
      return Constants;
    },
  },
  components: {
    // MyButton,
  },
};
</script>
